import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  EventEmitter,
  ViewEncapsulation,
  TemplateRef,
  Inject,
  ChangeDetectorRef,
  inject,
  PLATFORM_ID,
  effect,
  input
} from '@angular/core';
import { Params, Router } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';

import { ENVIRONMENT, Environment } from '@environment';
import { ChannelService } from '@usheru-hff/sdk/channel';
import { LocationService } from '@usheru-hff/sdk/location';
import { TrackingService } from '@usheru-hff/sdk/tracking';
import { Country, Movie, TabType, getMovieGenres, getMovieTags } from '@usheru-hff/shared/domain';
import { getDateFromDDMMYYYY } from '@usheru-hff/shared/utils';
import { ShowtimeStreamingService } from '@usheru-hff/shared/utils-movie';
import { TranslationsService } from '@usheru-hff/shared/utils-translation';

/**
 * Component to show in what places where a movie is available.
 *
 * //TODO barbeitoalex propostal - refractor name to something like "where-to-watch".
 * //TODO barbeitoalex propostal - organice life cycle methods. Split in specific method to improve docs.
 * //TODO barbeitoalex propostal - this could be simplificated a lot. Improbe the set of pageType, remove ngOnInit and use ngOnChange.
 * //TODO barbeitoalex propostal - use environment values in their own method and subscribe to environment changes
 * //TODO barbeitoalex propostal - move component folder to the root of components
 * //TODO barbeitoalex propostal - subscribe to current language to update the translate pipes
 */
@Component({
  selector: 'ush-showtime-streaming',
  templateUrl: './showtime-streaming.component.html',
  styleUrls: ['./showtime-streaming.component.scss']
  // encapsulation: ViewEncapsulation.None
})
export class ShowtimeStreamingComponent implements OnChanges {
  protected readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  /**
   * @docsNotRequired
   */
  // @Input()
  movie = input<Movie>();

  /**
   * Type of availavility of the movie to show.
   */
  // @Input()
  activeType: TabType;

  availableTypes: TabType[] = ['in-cinemas', 'watch-at-home', 'at-festivals', 'enquiries'];

  /**
   * Initial {@link pageTypes} if {@link activeType} is missing.
   */
  @Input()
  priorityType = false;

  @Input()
  customSubscribeTitleTr: string;

  @Input()
  customSubscribeDescTr: string;

  @Input() openFirstPanel = false;

  /**
   * @deprecard Don't found any use
   */
  params: Params;

  /**
   * If the there is only one {@link pageTypesOptions} shows the tab title.
   */
  @Input()
  showStreamingTitleAlways: boolean;

  @Input()
  inlineMap = false;

  /**
   * Used to prevent launch the tracking on multiple clicks in the {@link onChangeType} event.
   */
  beforeType: TabType;

  /**
   * Configuration for {@link ShowtimeStreamingSubscribeComponent}.
   *
   * //TODO barbeitoalex propostal - this value is necesary?
   */
  subscribeType: TabType;

  /**
   * List of tabs to show.
   */
  pageTypes: TabType[] = [];

  /**
   * Map version of {@link pageTypes}.
   */
  pageTypesOptions: SelectItem[] = [];

  /**
   * @deprecard Don't found any use
   */
  country: Country;

  /**
   * Used to set {@link pageTypes}. Activates if {@link areShowtimesAvailable}
   * and {@link disableShowtimes} is disabled.
   *
   * //TODO barbeitoalex propostal - Could be change to a get method and skip description.
   */
  showInCinemas = false;

  /**
   *  Used to set {@link pageTypes}. Activates if {@link movie}.locStreamingAvailable
   * or {@link isUplayerAvailable} and {@link disableStreaming} is disabled.
   *
   * //TODO barbeitoalex propostal - Could be change to a get method and skip description.
   */
  showWatchAtHome = false;

  /**
   * Used to set {@link pageTypes}. Activates if {@link movie}.movieFestivals.
   *
   * //TODO barbeitoalex propostal - Could be change to a get method and skip description.
   */
  showAtFestivals = false;

  /**
   * Used to set {@link pageTypes}. Activates if {@link forceDisableSubscription} is false
   * and {@link Channel} commsConsumerDemandit is present.
   *
   * //TODO barbeitoalex propostal - Could be change to a get method and skip description.
   */
  showDemandItForm = false;

  /**
   * Used to set {@link pageTypes}. Activates from {@link Environment} enquiries.
   */
  showEnquiries = false;

  @Input()
  hideTabs?: TabType[];

  // Templates refs
  @Input()
  inCinemasAddon?: TemplateRef<unknown>;

  /**
   * @docsNotRequired
   */
  private readonly disableShowtimes;

  /**
   * @docsNotRequired
   */
  private readonly disableStreaming;

  /**
   * Disables {@link showDemandItForm}.
   */
  @Input()
  forceDisableSubscription = false;

  @Input()
  enableRouterNavigation = true;

  @Input()
  showUsheruLogo = false;

  @Input()
  disableUplayer = false;

  @Input()
  widgetEnableTabs: TabType[] = [];

  /**
   * //TODO docs
   */
  @Output()
  servicesAvailables: EventEmitter<(TabType | 'subscribe')[]> = new EventEmitter();

  get paramType(): TabType {
    return this.activeType;
  }

  /**
   * Setted in {@link setUsePlaceholderData}.
   */
  usePlaceholderPerformancesGroup = false;

  /**
   * Setted in {@link setUsePlaceholderData}.
   */
  usePlaceholderStreamingLinks = false;

  streamingPlatformsLoadedTracked: boolean;
  showtimesLoadedTracked: boolean;
  noOptionsMessage: string;
  destroy$ = new Subject<void>();
  constructor(
    private channelService: ChannelService,
    private router: Router,
    private location: LocationService,
    private trackingService: TrackingService,
    private translationService: TranslationsService,
    private cd: ChangeDetectorRef,
    @Inject(ENVIRONMENT) private env: Environment,
    private showtimeStreamingService: ShowtimeStreamingService
  ) {
    this.disableShowtimes = this.channelService.channel.settings.disableShowtimes;
    this.disableStreaming = this.channelService.channel.settings.disableStreaming;
    this.forceDisableSubscription = this.env?.hideSubscriptionComponent;
    this.country = this.location.selectedCountry;
    effect(() => {
      const movie = this.movie();
      this.evaluateShowtimesStreamingAvailability(movie);
      this.evaluateComsumerDemandItSubscription();
      this.setUpNoOptionsMessage();
      this.filterVisibleTabs();
      this.evaluateActiveType();
    });
  }

  /**
   * @docsNotRequired
   */
  ngOnInit() {
    this.setUsePlaceholderData();
    // checking if website needs streaming title to be visible always
    if (this.env.showStreamingTitleAlways && this.showStreamingTitleAlways !== false)
      this.showStreamingTitleAlways = true;
  }

  // function that will determiny what value to set in the activeType variable
  evaluateActiveType() {
    this.showtimeStreamingService
      .determineShowtimeStreamingActiveType(this.movie(), this.hideTabs)
      .pipe(takeUntil(this.destroy$))
      .subscribe(activeType => {
        if(activeType) {
          this.setActiveType(activeType);
          this.cd.detectChanges();
        }
      });
  }

  evaluateShowtimesStreamingAvailability(movie: Movie) {
    // verify if in cinemas and streaming are not disabled by hideTabs
    if (this.hideTabs?.includes('in-cinemas')) {
      this.showInCinemas = false;
    } else {
      this.showInCinemas = this.showtimeStreamingService.determineInCinemasAvailability(movie);
    }
    if (this.hideTabs?.includes('watch-at-home')) {
      this.showWatchAtHome = false;
    } else {
      this.showWatchAtHome = this.showtimeStreamingService.determineStreamingAvailability(movie);
    }
    this.showEnquiries = this.showtimeStreamingService.determineEnquiriesAvailability();
    this.showAtFestivals = this.showtimeStreamingService.determineFestivalsAvailability(movie);
  }

  evaluateComsumerDemandItSubscription() {
    if (this.forceDisableSubscription) {
      this.showDemandItForm = false;
      return;
    }
    this.displayDemandItForm();
  }

  filterVisibleTabs() {
    // filtering what witgets can be shown

    // method that will populate this.pageTypes with the available tabs
    this.enableTabs();

    // pageTypesOptions is the map version of pageTypes
    this.pageTypesOptions = this.pageTypes.map(type => ({
      label: type,
      value: type
    }));
  }

  /**
   * * Set the {@link pageType} after {@link movie} changes.
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['movie']?.firstChange) return;
    // if (changes['activeType']?.currentValue !== changes['activeType']?.previousValue) {
    //   this.onChangeType(this.activeType);
    // }

    if (this.moviesAreDifferent(changes.movie?.currentValue as Movie, changes.movie?.previousValue as Movie)) {
      const movie = changes['movie']?.currentValue;
      // const type = changes['activeType']?.currentValue;
      this.showtimesLoadedTracked = false;
      this.streamingPlatformsLoadedTracked = false;

      this.evaluateShowtimesStreamingAvailability(movie);
      this.filterVisibleTabs();

      const services = this.pageTypesOptions.map(item => item.value);

      if (this.showDemandItForm) services.push('subscribe');
      this.servicesAvailables.next(services);

      // if during movie detail routing active type is undefiend use the first pageType Option available
      // if ((!this.activeType || this.activeTypeDoesNotExists()) && this.pageTypes?.length > 0) {
      //   this.setActiveType(this.pageTypes[0]);
      // }
    }
  }

  moviesAreDifferent(previousMovie: Movie, newMovie: Movie): boolean {
    if (
      previousMovie?.friendlyUrl != newMovie?.friendlyUrl ||
      previousMovie?.locStreamingAvailable != newMovie?.locStreamingAvailable ||
      previousMovie?.locCinemaEnd != newMovie?.locCinemaEnd
    )
      return true;
    return false;
  }

  /**
   * Updates tracking after change the tab
   * @param event
   */
  onChangeType(event: TabType) {
    this.setActiveType(event);
    this.subscribeType = null;
    if (!this.beforeType != null && this.beforeType !== event) {
      this.beforeType = this.activeType;
      this.trackingService.trackEvent({
        action: 'ChangeTab',
        properties: {
          label: `${this.movie().title} @ ${this.activeType}`,
          category: 'MovieDetail',
          movie: this.movie().title,
          idMovie: this.movie().id,
          imdb: this.movie()?.imdb,
          tagsMovie: getMovieTags(this.movie()),
          genresMovie: getMovieGenres(this.movie())
        }
      });
    }
    this.updateQueryParams();
  }

  // todo: we could probably move this to afterRender hook in constructor
  updateQueryParams() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const url = new URL(document.location as any);
    if (this.env.appType === 'widget') {
      url.searchParams.set('whereToWatch', this.activeType);
    } else {
      url.searchParams.set('section', this.activeType);
    }

    history.pushState({}, '', url.toString());
  }

  /**
   * @docsNotRequired
   */
  enableTabs() {
    this.pageTypes = [];
    const placeholderAvailable = this.env.mode == 'develop' || this.env?.mode == 'local';
    const placeholderPerformancesGroup = placeholderAvailable
      ? this.env?.placeholderData?.performancesGroup
      : undefined;
    const placeholderStreamingLinks = placeholderAvailable ? this.env?.placeholderData?.streamingLinks : undefined;
    (this.showInCinemas || placeholderPerformancesGroup) && this.pageTypes.push('in-cinemas');
    (this.showWatchAtHome || placeholderStreamingLinks) && this.pageTypes.push('watch-at-home');
    this.showAtFestivals && this.pageTypes.push('at-festivals');
    this.showEnquiries && this.pageTypes.push('enquiries');

    this.handleWidgetsTabsAvailability();
  }

  handleWidgetsTabsAvailability() {
    if (this.widgetEnableTabs.length > 0) {
      // compare widgetEnableTabs to pageTypes and only show the tabs that are available in both
      this.pageTypes = this.pageTypes.filter(type => this.widgetEnableTabs.includes(type));
    }
  }

  onShowtimeTicketingHandle(performanceId) {
    this.router.navigateByUrl(`/get-tickets/${performanceId}`);
  }

  areShowtimesOrStreamingAvailable(): boolean {
    return this.activeType == 'in-cinemas' ? this.showInCinemas : this.showWatchAtHome;
  }

  /**
   * Check if there are invalid entries in {@link pageTypes}.
   *
   * //TODO barbeitoalex propostal - I think this is not necessary.
   */
  activeTypeDoesNotExists() {
    if (this.pageTypes.includes(this.activeType)) {
      return false;
    }
    return true;
  }

  /**
   * Sets {@link usePlaceholderPerformancesGroup} to only work in local enviroment if is available.
   */
  setUsePlaceholderData() {
    if (this.env.mode == 'develop') {
      this.usePlaceholderPerformancesGroup = !!this.env?.placeholderData?.performancesGroup || false;
      if (this.usePlaceholderPerformancesGroup && !this.widgetEnableTabs.includes('in-cinemas'))
        this.widgetEnableTabs.push('in-cinemas');
      this.usePlaceholderStreamingLinks = !!this.env?.placeholderData?.streamingLinks || false;
      if (this.usePlaceholderStreamingLinks && !this.widgetEnableTabs.includes('watch-at-home'))
        this.widgetEnableTabs.push('watch-at-home');
    } else {
      this.usePlaceholderPerformancesGroup = false;
    }
  }

  /**
   * Method that will track the StreamingLoaded event if there are streams present.
   */
  onStreamingPlatformsLoaded() {
    if (!this.streamingPlatformsLoadedTracked) {
      this.streamingPlatformsLoadedTracked = true;
      this.trackingService.trackEvent({
        action: 'StreamingLoaded',
        properties: {
          category: 'MovieStreaming',
          label: `${this.movie().title}`,
          movie: this.movie().title,
          idMovie: this.movie().id,
          imdb: this.movie()?.imdb,
          tagsMovie: getMovieTags(this.movie()),
          genresMovie: getMovieGenres(this.movie())
        }
      });
    }
  }

  /**
   * Method that will track ShowtimesLoaded action if ther are performances present.
   */
  onShowtimesLoaded() {
    // only track if performances exists for this movie
    if (!this.showtimesLoadedTracked) {
      this.showtimesLoadedTracked = true;
      this.trackingService.trackEvent({
        action: 'ShowtimesLoaded',
        properties: {
          category: 'MovieShowtimes',
          label: `${this.movie().title}`,
          movie: this.movie().title,
          idMovie: this.movie().id,
          imdb: this.movie()?.imdb,
          tagsMovie: getMovieTags(this.movie()),
          genresMovie: getMovieGenres(this.movie())
        }
      });
    }
  }

  setActiveType(type: TabType) {
    this.activeType = this.availableTypes.includes(type) ? type : 'in-cinemas';
    this.cd.detectChanges();
  }

  private displayDemandItForm(): void {
    this.showDemandItForm = this.showtimeStreamingService.isDemandItFormEnabled(this.movie());
  }

  setUpNoOptionsMessage() {
    if (this.isMovieReleased()) {
      this.noOptionsMessage = this.translationService.translate(
        'public.commons.whereToWatch.noOptionsReleased',
        'No options available yet. Please check back later.'
      );
    } else {
      this.noOptionsMessage = this.translationService.translate(
        'public.commons.whereToWatch.noOptionsNoReleased',
        'No options available yet. Please check back later.'
      );
    }
  }

  isMovieReleased(): boolean {
    const releaseDate = getDateFromDDMMYYYY(this.movie()?.releaseDate);
    const now = new Date();
    return releaseDate <= now;
  }
}
